import { IconButton, Typography } from '@mui/material'
import Link from 'next/link'
import React from 'react'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { useNetwork } from 'wagmi'
import { FlexCol } from '@/components/common/Columns'
import { RowCenterY } from '@/components/common/Rows'
import { CHAIN_INFO } from '@/constants'
import { FARM_ADDRESS, PROJECT_SITE } from '@/constants/contract/contractAddress'

const ExternalLinkGroup = ({ poolId }: { poolId: number }) => {
  const { chain } = useNetwork()

  return (
    <FlexCol sx={{ rowGap: 4, alignItems: 'end' }}>
      {PROJECT_SITE?.[poolId] && (
        <RowCenterY sx={{ color: '#BFFF0B' }}>
          <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>Project site</Typography>

          <Link href={PROJECT_SITE[poolId]} target="_blank">
            <IconButton size="small">
              <OpenInNewIcon sx={{ width: 16, height: 16, color: '#BFFF0B' }} />
            </IconButton>
          </Link>
        </RowCenterY>
      )}

      <RowCenterY sx={{ color: '#BFFF0B' }}>
        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>Staked address</Typography>
        <Link
          href={`${CHAIN_INFO?.[chain?.id].blockExplorers.default.url}/address/${FARM_ADDRESS?.[chain?.id]}`}
          target="_blank"
        >
          <IconButton size="small">
            <OpenInNewIcon sx={{ width: 16, height: 16, color: '#BFFF0B' }} />
          </IconButton>
        </Link>
      </RowCenterY>
    </FlexCol>
  )
}

export default ExternalLinkGroup
